export const projectsData = [
  {
    id: 1,
    title: "Chromaly",
    // Card teaser — short hook
    description: "A visual language learning app using color to decode character structure. Built with React and SVG.",
    // Panel detail — full story
    details: "Building a visual language learning app that helps users understand character structure through color-coded decomposition and interactive stroke tracing.",
    role: "Founder & Software Engineer",
    duration: "Apr 2026 – Present",
    badge: "In Development",
    featured: true,
    technologies: ["React", "SVG", "JavaScript", "TypeScript"],
    achievements: [
      "SVG-based interactive stroke tracing with guided and outline-free practice modes",
      "Color-coded character segmentation to highlight shared subcomponents",
      "Accessibility modes including color-blind friendly and high-contrast options",
      "Scalable data models designed to expand beyond Japanese to other character-based languages",
      "User-focused learning flows inspired by spaced repetition"
    ],
    link: null
  },
  {
    id: 2,
    title: "American Express",
    // Card teaser — punchy and specific
    description: "Frontend Engineer on the core Dashboard team. Shipped features to millions of users globally.",
    // Panel detail — full resume detail
    details: "Shipped multiple features to the core AMEX Dashboard app used by tens of thousands of daily users across international and US markets.",
    role: "Frontend Software Engineer",
    duration: "Mar 2022 – Oct 2024",
    badge: "2022 – 2024",
    impact: "Payment button feature used by millions, improving checkout speed and reliability",
    technologies: ["React", "TypeScript", "JavaScript", "Jest", "Redux"],
    achievements: [
      "Launched a new payment button feature used by millions of users globally",
      "Increased unit test coverage by 25%+ using Jest; led tech debt refactor efforts",
      "Decreased accessibility violations via keyboard navigation and screen reader improvements",
      "Developed performant, reusable React components for international markets",
      "Authored onboarding guides, accessibility best practices, and module documentation",
      "Proactively closed known security vulnerabilities and updated outdated dependencies"
    ],
  },
  {
    id: 3,
    title: "Tech Stack",
    // Card teaser
    description: "React, TypeScript, Node.js, and more — built up through Grace Hopper Academy and 2.5 years at AMEX.",
    // Panel detail
    details: "Built up through Grace Hopper Academy, self-study, and production work at American Express — with a focus on modern React ecosystems and accessibility.",
    badge: "Skills",
    technologies: [
      "JavaScript (ES6+)", "TypeScript", "React", "Node.js",
      "Express", "Redux", "HTML5", "CSS3",
      "Jest", "Git", "PostgreSQL", "Docker",
      "Vercel", "Heroku", "REST APIs", "SVG"
    ],
    learningPath: {
      education: "Grace Hopper Program at Fullstack Academy",
      location: "New York City, 2022",
      continuation: "Deepened through 2.5 years at American Express and ongoing independent projects"
    },
    languages: [
      "English (Native)", "Bengali (Native)", "Japanese (Intermediate)", "Spanish (Beginner)"
    ]
  }
];
